import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter, HostListener,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {LocalStorageService, SessionStorageService} from 'angular-web-storage';
import {isUndefined} from 'util';
import {BehaviorSubject, finalize, from, fromEvent, ObservableInput, ReplaySubject, Subject, Subscription, throttleTime} from 'rxjs';
import {catchError, debounceTime, filter, takeUntil} from 'rxjs/operators';
import {TelegramService} from '../../pages/page-telegram/telegram.service';
import {IMessage} from '../../services/websocket';
import {TimeagoIntl} from 'ngx-timeago';
import {strings as rusStrings} from 'ngx-timeago/language-strings/ru';
import {ContextMenuComponent} from 'ngx-contextmenu';
import {ModalService} from '../../services/modal.service';
import {NotifierWrapService} from '../../services/notifier-wrap.service';
import {NzModalService} from 'ng-zorro-antd/modal';
import {AllService} from '../../services/all.service';
import {WhatsappService} from '../../pages/page-whatsapp/whatsapp.service';
import {Chat, IMessengerConnector, Message, MessageUser, UserName} from '../../types/all.type';
import {AllMessengersService} from '../../pages/page-start/all-messengers.service';
import {Router} from '@angular/router';
import {isMobile, log} from '../../functions';
import {InterfaceService} from '../../services/interface.service';
import {CallService} from '../../services/call.service';
import {AppService} from '../../services/app.service';
import {SenderService} from '../../services/sender.service';
import {AuthService} from '../../modules/auth/services/auth.service';
import {DcService} from '../../services/dc.service';


@Component({
  selector: 'app-chat-list',
  templateUrl: './chat-list.component.html',
  styleUrls: ['./chat-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChatListComponent implements OnInit, OnDestroy {
  public loadChats$: ReplaySubject<string> = new ReplaySubject();
  public isFirstLoad = true;
  loadData = [
    {title_width: 100},
    {},
    {title_width: 150},
    {},
    {},
    {title_width: 80},
    {},
    {title_width: 140},
    {},
    {},
    {title_width: 95},
    {},
    {title_width: 100},
    {},
    {}
  ];
  public isLoaded$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public isLoadError$: BehaviorSubject<false | Error> = new BehaviorSubject(false);
  public showCount$: BehaviorSubject<number> = new BehaviorSubject(15);
  @Input() type: string;
  @Input() Service: IMessengerConnector;
  @Output() onSettings = new EventEmitter<any>();
  onlyUnread = false;
  loadResultsTimeout: NodeJS.Timeout;
  loadResultsSubscription: Subscription = new Subscription();
  @ViewChild(ContextMenuComponent) public contextMenu: ContextMenuComponent;
  @ViewChild('scrollable') scrollable: ElementRef;
  reloadTimeout: NodeJS.Timeout;
  public openChatDropdown: Chat;

  detectChanges$: ReplaySubject<string> = new ReplaySubject();
  detectChangesNoCritical$: ReplaySubject<string> = new ReplaySubject();
  chatsResort$: ReplaySubject<void> = new ReplaySubject();
  chatsResortThrottle$: ReplaySubject<void> = new ReplaySubject();
  private countChats: number;

  private destroy$: Subject<void> = new Subject();

  @HostListener('window:focus', ['$event'])
  onWindowFocus(event: FocusEvent) {
    this.cd.detectChanges();
  }

  constructor(
    private dcService: DcService,
    private authService: AuthService,
    public senderService: SenderService,
    public appService: AppService,
    public router: Router,
    public allMessengersService: AllMessengersService,
    private modal: NzModalService,
    public notifierWrapService: NotifierWrapService,
    public modalService: ModalService,
    private zone: NgZone,
    public cd: ChangeDetectorRef,
    private intl: TimeagoIntl,
    public allService: AllService,
    public telegramService: TelegramService,
    public whatsappService: WhatsappService,
    public local: LocalStorageService,
    public session: SessionStorageService,
    public interfaceService: InterfaceService,
    public callService: CallService
  ) {
    this.intl.strings = rusStrings;

    // this.intl.strings.seconds = 'меньше 1 мин.';
    /*this.intl.strings.year = 'г.';
        this.intl.strings.month = 'м.';
        this.intl.strings.day = 'д.';
        this.intl.strings.hour = 'ч.';
        this.intl.strings.minute = 'мин.';
        this.intl.strings.minute = 'мин.';*/

    this.intl.changes.next();
  }

  ngOnInit(): void {
    // console.log(this.allMessengersService.getServicesFilter('isAuth', false));
    /*this.cd.detach();
    this.cd.detectChanges();*/
    this.loadChats$.pipe(takeUntil(this.destroy$)).subscribe((initiator) => {
      if (this.loadResultsSubscription) {
        this.loadResultsSubscription.unsubscribe();
      }
    });
    this.loadChats$.pipe(takeUntil(this.destroy$), debounceTime(3000)).subscribe((initiator) => {
      this.loadChats(initiator);
    });
    this.interfaceService.reLoadChats$.pipe(takeUntil(this.destroy$), throttleTime(300000)).subscribe((initiator) => {
      console.error('TODO add reload chat, not find chat!!!!');
      this.loadChats('reLoadChats$');
    });
    this.interfaceService.reLoadChatsForce$.pipe(takeUntil(this.destroy$), debounceTime(5000)).subscribe((initiator) => {
      this.loadChats('reLoadChatsForce$');
    });
    this.dcService.detectChangesConnect$.subscribe(() => {
      this.detectChanges$.next('detectChangesConnect$');
    });
    this.reload('init');

    this.allService.setService$.pipe(takeUntil(this.destroy$)).subscribe((component) => {
      this.cd.detectChanges();
      this.reload('reload setService$');
    });
    this.allMessengersService.setService$.pipe(takeUntil(this.destroy$)).subscribe((component) => {
      // this.reload('reload allMessengersService setService$', 100);
    });
    this.allService.login$.pipe(takeUntil(this.destroy$)).subscribe((Service) => {
      this.reload('reload login$');
      /*const isExist = this.allService.arChat.filter(v => v.service_type === Service.type)
      if(!isExist) {

        this.detectChanges();
      }*/
    });
    setTimeout(() => {
      this.dcService.detectChanges$.pipe(
        filter(v => v === 'chat-list'), takeUntil(this.destroy$)
      ).subscribe((component) => {
        this.detectChanges$.next('dcService.detectChanges$');
      });

      this.allService.wsService.status.pipe(takeUntil(this.destroy$), filter(v => !!v)).subscribe((status) => {
        if (this.allService.wsService.isConnected && this.isLoaded$.value) {
          this.loadChats$.next(`wsService: ${status}`);
        }
      });



      this.allService.wsService.on<IMessage>('new_message').pipe(takeUntil(this.destroy$)).subscribe((data) => {
        this.onNewMessage(data.new_message, data.path);
      });


      this.allService.newMessage$.pipe(takeUntil(this.destroy$), filter(v => !!v)).subscribe((resultMessage) => {
        this.onNewMessage(resultMessage, resultMessage?.service_class || this.allMessengersService.Service.type);
      });

    }, 1500);

    if (this.scrollable) {
      this.zone.runOutsideAngular(() => {
        fromEvent(this.scrollable?.nativeElement, 'scroll')
          .pipe(
            takeUntil(this.destroy$),
            // throttleTime(50),
            debounceTime(200),
            // Is elementId scrolled for more than 50 from top?
            filter((e: Event) => (e.srcElement as Element).scrollHeight - (e.srcElement as Element).scrollTop < 1500)
            // takeUntil(this.destroy$),
          )
          .subscribe((v) => {
            this.lazyLoad(true);
          });
      });
    }
    this.detectChanges$.pipe(debounceTime(500), takeUntil(this.destroy$)).subscribe((text) => {
      this.detectChanges('$ ' + text);
    });
    this.detectChangesNoCritical$.pipe(debounceTime(3000), takeUntil(this.destroy$)).subscribe((text) => {
      this.detectChanges('detectChangesNoCritical$ ' + text);
    });

    this.chatsResort$.pipe(debounceTime(3000), takeUntil(this.destroy$)).subscribe(() => {
      console.error('chatsResort$');
      this.chatsResort();
    });
    this.chatsResortThrottle$.pipe(throttleTime(10000), takeUntil(this.destroy$)).subscribe(() => {
      console.error('chatsResortThrottle$');
      this.chatsResort();
    });
  }

  detectChanges(text: string): void {
    if (this.interfaceService.isFocused() || !this.isFirstLoad) {
      log('ChatListComponent detectChanges', text, new Date().getSeconds());
      this.cd.detectChanges();
    }
  }

  /// Context Menu
  public onContextMenu(item: Chat) {
    // log(item);
  }



  openProfile(chat: Chat) {
    let chatService = this.Service;
    chatService = this.allMessengersService.getService(chat.service_type) || chatService;
    this.modalService.openModal('ModalChatDetailComponent', {
      Service: chatService,
      id: chat.id,
      initData: chat
    });
  }

  openAddChatMember(chat: Chat) {
    let chatService = this.Service;
    chatService = this.allMessengersService.getService(chat.service_type) || chatService;
    this.modalService.openModal('ModalAddChatMemberComponent', {
      Service: chatService,
      chatId: chat.id
    });
  }

  public isChatPinned(item: Chat): boolean {
    return item.is_pinned;
  }

  public isNotChatPinned(item: Chat): boolean {
    return !item.is_pinned;
  }

  public isUnread(item: Chat): boolean {
    return item.unread_messages_count > 0;
  }

  public isLeave(item: Chat): boolean {
    return item.type !== 'private';
  }

  public isInvite(item: Chat): boolean {
    return item.type !== 'private';
  }

  public isNotificationsSupport(item: Chat): boolean {
    // const chatService = this.allMessengersService.getService(item.service_type);
    return item.service_type !== 'vk';
  }

  getChatService(serviceType: string): IMessengerConnector {
    let chatService = this.Service;
    chatService = this.allMessengersService.getService(serviceType) || chatService;
    return chatService;
  }

  /////////
  onNewMessage(newMessage: Message, serviceType = '') {
    // log('newMessage', newMessage, serviceType, 'isLoaded', this.isLoaded);
    const chat = this.allService.arChat.find((v: Chat) => v.id === newMessage.chat_id && v.service_type === serviceType);
    log(newMessage, serviceType);
    if (chat) {
      chat.typing = false;
      chat.last_message = newMessage;
      if (!chat.last_message.out) {
        // chat.unread_messages_count++;
      } else {
        chat.unread_messages_count = 0;
      }
      if (chat.type === 'private' || this.interfaceService.filterType !== 'private') {
        this.chatsResortThrottle$.next();
      }
      this.allService.saveLocalChats$.next();
    }
    if (!this.isLoaded$.value) {
      return;
    }
    if (!chat) {
      // TODO доработать chat_type
      if (serviceType?.length > 0 && newMessage.chat_type === 'private') {
        log('Start add chat:' + serviceType + ' ' + chat?.id, newMessage.chat_id);
        // const chatService = this.getChatService(serviceType);
        // this.interfaceService.reLoadChats$.next();
        this.allService.arChat.push({
          id: newMessage.chat_id,
          type: newMessage.chat_type,
          username: '',
          service_type: serviceType,
          unread_messages_count: 1,
          name: newMessage.name,
          last_message: newMessage,
          avatar: newMessage.avatar,
          avatar_file_id: newMessage.avatar_file_id,
          avatar_file_unique_id: newMessage.avatar_file_unique_id,
        });
        this.chatsResort();
      }
    }
  }

  chatsResort() {
    this.allService.arChat = this.appService.chatSort(this.allService.arChat);
    this.detectChanges('chatsResort');
  }

  reload(initiator = 'none') {
    if (this.arChat?.length === 0) {
      this.loadChats$.next(initiator);
    } else {
      this.loadData = [];
      this.detectChanges('reload');
      this.loadChats$.next(initiator);
    }
  }

  trackByFn(index, element: Chat) {
    return element.id + element.service_type;
  }

  loadChats(initiator = 'none') {
    console.warn('LoadChats', initiator);
    this.isLoadError$.next(false);
    this.isLoaded$.next(false);
    log('loadChats', this.Service.type, initiator);
    this.loadResultsSubscription = this.Service.chatList(this.interfaceService.filterType)
      .pipe(
        takeUntil(this.destroy$),
        catchError((e, caught): any => {
          this.isLoadError$.next(e);
          this.isLoaded$.next(true);
          this.cd.detectChanges();
        }),
        finalize(() => {
          this.isLoaded$.next(true);
          this.cd.detectChanges();
        })).subscribe(
      (result: any) => {
        this.allService.loadedChats$.next();
        log('chatList: ', result?.length);
        from(result.results)
          .pipe(filter((chat: any) => chat.id))
          .subscribe((chat: Chat) => {

            let chatService = this.Service;
            if (!(this.Service instanceof AllMessengersService)) {
              chat.service_type = this.Service.type;
              chat.isSelf = this.Service.arProfile?.id === chat.id;
              this.Service.unreadCount += chat.unread_messages_count || 0;
            } else {
              chatService = this.getChatService(chat.service_type);
              chat.isSelf = chatService.arProfile?.id === chat.id;
              chatService.unreadCount += chat.unread_messages_count || 0;
            }
            if (chat?.last_message?.text_list) {
              this.callService.replaceCallMessage(chat?.last_message, chatService);
              chat.last_message.text_list = chat.last_message.text_list.replace(/(<([^>]+)>)/gi, '');
            }
            chat.color = this.appService.stringToHslColor(chat.id);
          });
        result.results = result.results.filter((v) => v.service_type?.length > 0);
        this.senderService.addHelpChat(result.results);

        ///
        this.allMessengersService.mergeChats(result.results);

        this.allService.saveLocalChats$.next();
        this.loadData = [];
        // При первой загрузке отображать сразу
        if (this.isFirstLoad) {
          this.chatsResort();
        } else {
          this.chatsResort$.next();
        }
        ///
        setTimeout(() => {
          this.checkExpiredChatsHistory();
        }, 500);
        this.detectChanges$.next('loadChats api');
        this.isFirstLoad = false;
      },
      (e) => {
        if (!(this.Service instanceof AllMessengersService)) {
          // this.interfaceService.errorHandling(e, true, this.Service);
        }
        this.allService.loadedChats$.next();
        this.isLoaded$.next(true);
        this.isLoadError$.next(e);
        this.cd.detectChanges();
      }
    );
  }

  checkExpiredChatsHistory() {
    this.allService.arChat.forEach((chat: Chat) => {
      const chatService = this.getChatService(chat.service_type);
      const chatHistory = chatService.arLocalHistory[chat.id];
      if (chatHistory && chatHistory?.length > 0) {
        chat.expired_history = chat?.last_message?.id !== chatHistory[chatHistory?.length - 1]?.id;
      }
    });
    this.allService.saveLocalChats$.next();
  }

  openSettings() {
    this.onSettings.emit(true);
  }

  get runChangeDetection() {
    this.allService.arDetectChangesLog.ChatListComponent++;
    return '';
  }

  onScrollIndex(event) {
    this.cd.reattach();
    this.detectChanges('onScrollIndex');
    if (event % 3 === 0) {
      // this.detectChanges()
    }
    this.cd.detach();
  }

  onlyUnreadToggle() {
    this.onlyUnread = !this.onlyUnread;
    this.detectChanges$.next('onlyUnreadToggle');
  }

  toggleChatPine(chat) {
    const chatService = this.getChatService(chat.service_type);
    chatService.toggleChatPine(chat.id, chat.is_pinned ? null : true).subscribe(
      (result: any) => {
        if (isUndefined(result.error_msg)) {
          chat.is_pinned = !chat.is_pinned;
          this.cd.detectChanges();
          this.chatsResort$.next();
          this.allService.saveLocalChats$.next();
        } else {
          this.notifierWrapService.notify('error', result.error_msg);
        }
        this.interfaceService.toggleChatPine$.next(chat);
      },
      (e) => {
        this.interfaceService.errorHandling(e);
      }
    );
  }

  readHistory(chat) {
    log('readHistory', chat);
    const chatService = this.getChatService(chat.service_type);
    chatService.readHistory(chat.id, chat.last_message.id).pipe(takeUntil(this.destroy$)).subscribe(
      () => {
        chat.unread_messages_count = 0;
        this.detectChangesNoCritical$.next('readHistory');
      },
      (e) => {
        this.interfaceService.errorHandling(e);
      }
    );
  }

  alert() {
    alert('lol');
  }

  lazyLoad(vizible): void {
    if (vizible && this.countChats > this.showCount$.value) {
      this.showCount$.next(this.showCount$.value + 15);
      console.log('ChatListComponent', 'lazyLoad');
      this.cd.detectChanges();
    }
  }

  get arChat(): Chat[] {
    let list: Chat[] = [];
    if (!(this.Service instanceof AllMessengersService)) {
      const result = this.allService.arChat.filter((v) => v.service_type === this.Service.type);
      this.countChats = result?.length;
      list = this.allService.arChat.filter((v) => v.service_type === this.Service.type);
    } else {

      this.countChats = this.allService.arChat?.length;
      list = this.allService.arChat;
    }
    if (this.interfaceService.filterType !== '') {
      if (this.interfaceService.filterType === 'private') {
        list = list.filter((v) => v.type === 'private' || v.type === 'support');
      }else if (this.interfaceService.filterType === 'group') {
        list = list.filter((v) => v.type === 'channel' || v.type === 'group' || v.type === 'support');
      }
    }
    return list;
  }

  logout(): void {
    this.allMessengersService.arServices.map((Service) => {
      this.authService.logout(Service);
    });
    this.allService.setToken();
  }

  public showMobileHome() {
    this.allMessengersService.Service._openChatId = false;
    this.interfaceService.openChat$.next(false);
    delete this.allService._openChatId;
    this.allService.isCloseChat = true;
    if (!isMobile()) {
      this.allService.setService$.next('all');
    }
    this.interfaceService.showMobileHome = true;
  }


  setFilter(value: string) {
    this.loadChats('setFilter');
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    clearTimeout(this.reloadTimeout);
    this.loadResultsSubscription.unsubscribe();
  }
}
